import axios from "axios";
import { API_URL } from "../commons/envs"

const _baseUrl = API_URL;

const httpClient = axios.create({
  baseURL: _baseUrl,
});

export default httpClient;
